import React from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { formatFinance } from "../../../../utils/formatters";

// Register the required components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const ReportAverageTicketChart = ({
  items,
  label = "Relatório de Ticket Médio",
  showLegend = false,
}) => {
  const labels = items.map((item) => item.title);

  // Calculate the average ticket for each item
  const data = {
    labels,
    datasets: [
      {
        label: "Ticket Médio",
        data: items.map((item) =>
          item.order_count > 0 ? item.total_order_value / item.order_count : 0
        ),
        backgroundColor: [
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
          "rgba(255, 159, 64, 0.6)",
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
        ],
        borderColor: [
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: showLegend,
      },
      title: {
        display: true,
        text: label,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const item = items[tooltipItem.dataIndex];
            const averageTicket =
              item.order_count > 0
                ? item.total_order_value / item.order_count
                : 0;
            return [
              `Ticket Médio: R$${averageTicket.toFixed(2)}`,
              `Quantidade de Pedidos: ${item.order_count}`,
            ];
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "top",
        formatter: (value) => formatFinance(value),
        font: {
          weight: "bold",
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default ReportAverageTicketChart;
